export const state = () => ({
  lastCreatedRecord: null,
})

export const mutations = {
  SET_NEW_RECORD(state, record) {
    state.lastCreatedRecord = record
  },
}
